import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import useRetrieveLatestAutomationVersion from '@/hooks/api/automationVersions/useRetrieveLatestAutomationVersion.ts';
import { get_editor_local_subflow_context_url } from '@/utils/urls.ts';
import {
  StepDataOutputs,
  StepOutputContracts,
} from '@/types/automationFields.ts';
import { AutomationLocalSubflowPort } from '@/types/automations.ts';

export type EditorLocalSubflowContext = StepDataOutputs & StepOutputContracts & {
  source_version_id: string;
  subflow_id: string;
  input_ports: AutomationLocalSubflowPort[];
  children_data_outputs: StepDataOutputs['step_data_outputs'];
};

const useRetrieveEditorLocalSubflowContext = (subflowId?: string) => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const { data: latestVersion } = useRetrieveLatestAutomationVersion();

  return useQuery({
    queryKey: ['editor-local-subflow-context', automationId, latestVersion?.id, subflowId],
    enabled: Boolean(automationId && latestVersion?.id && subflowId),
    queryFn: async () => (
      await apiClient.get<EditorLocalSubflowContext>(
        get_editor_local_subflow_context_url(automationId, subflowId),
        { suppressGlobalErrorToast: true },
      )
    ).data,
    retry: false,
    meta: { suppressGlobalErrorToast: true },
  });
};

export default useRetrieveEditorLocalSubflowContext;
